import { utcToZonedTime } from 'date-fns-tz';
import { useCallback } from 'react';

import { useCurrentUserClientTimezone } from '../../contexts/OidcContext/OidcContext.selectors';
import { useDateFnsFormat } from '../../hooks/useDateFnsFormat';

export const useFormattedTime = () => {
    const dateFormat = useDateFnsFormat();
    const timezone = useCurrentUserClientTimezone();

    return useCallback(
        (date: number | Date, format = 'HH:mm') => dateFormat(utcToZonedTime(date, timezone || ''), format),
        [dateFormat, timezone],
    );
};
